import {toast} from 'react-toastify';

export type ValueType = string | number;
/**
 * copy value to the clipboard
 * @param {ValueType} value
 * @return {void}
 */
export default async function copyToClipboard(
    value: ValueType,
): Promise<void> {
  try {
    return await navigator
        .clipboard
        .writeText(String(value))
        .then();
  } catch (error) {
    toast.error('Ошибка копирования');
    throw error;
  }
}
